import React, { useEffect } from 'react'
import { EvidenceWrapper } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { AccordionGridBody } from 'src/components/Reusable/Grid/Accordion'
import { useLocation } from 'react-router-dom'
import { ReceptorScanContextProvider } from 'src/context/ReceptorScanStatus'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useNewModel } from 'src/components/async/hooks/useNewModel'
import { EvidenceAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useIsContentSearchActive } from 'src/Utils/search/search.hooks'
import {
  IndexingStatusProvider,
  useIndexingStatusResolver,
} from 'src/components/Reusable/IndexingStatus/IndexingStatusContext'
import { useEvidenceIndexGridTemplateColumns } from '../evidence.hooks'
import {
  EvidenceIndexGridHeader,
  evidenceWrapperRowItems,
} from './EvidenceGrid.components'
import { StyledEvidenceGrid } from './EvidenceGrid.styles'

export const EvidenceGrid = ({
  evidenceWrappers,
  onUpdate,
}: {
  evidenceWrappers: EvidenceWrapper[]
  onUpdate: () => Promise<void>
}): JSX.Element => {
  const location = useLocation()
  const isContentSearchActive = useIsContentSearchActive()
  const newModel = useNewModel()

  const resolveIndexingStatus = useIndexingStatusResolver(
    evidenceWrappers.map((w) => w.getContentId()),
    evidenceWrappers.map((w) => w.getIndexingStatus()),
  )
  useEffect(() => {
    const savedPosition = sessionStorage.getItem(
      `scrollPosition-${location.pathname}`,
    )
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10))
      sessionStorage.removeItem(`scrollPosition-${location.pathname}`)
    }
  }, [location])

  const hasSharepoint = IsGatekeeperEnabled(GatekeeperFlag.SHAREPOINT)
  const isEvidenceIndexPage = location.pathname.includes(
    EvidenceAbsoluteRoutes.INDEX,
  )
  const showContentMatchColumn = isContentSearchActive && isEvidenceIndexPage
  const gridTemplateColumns = useEvidenceIndexGridTemplateColumns(hasSharepoint)
  const templateColumns = showContentMatchColumn
    ? `min-content ${gridTemplateColumns}`
    : gridTemplateColumns

  return (
    <ReceptorScanContextProvider>
      <IndexingStatusProvider resolve={resolveIndexingStatus}>
        <StyledEvidenceGrid gridTemplateColumns={templateColumns}>
          <EvidenceIndexGridHeader
            showContentMatchColumn={showContentMatchColumn}
          />
          <AccordionGridBody
            items={evidenceWrapperRowItems({
              evidenceWrappers,
              onUpdate,
              newModel,
              resolveIndexingStatus,
            })}
            gridTemplateColumns={templateColumns}
            nothingToShow={<></>}
          />
        </StyledEvidenceGrid>
      </IndexingStatusProvider>
    </ReceptorScanContextProvider>
  )
}
